<template>
	<div class="k-page-content" v-loading="loading">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="资源详情" name="first">
				<div class="k-page-common">
					<div class="k-common-header" style="padding: 12px;">
						<div class="proDeTitle">
							<div>
								<span class="t1">资源详情：</span>
								<span class="t2">{{ resourceData.resource_info.name }}（{{ resourceData.resource_info.account_code
								}}）</span>
								<span class="t3">{{ resourceData.resource_info.status_txt }}</span>
							</div>
							<div class="back" @click="goBack()">
								<i class="el-icon-back"></i>返回上一页
							</div>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="whiteBox">
								<div class="resourceDetailTop">
									<div class="tyTitle">
										<p>资源信息</p>
									</div>
									<layoutStep v-if="resourceData.resource_info.account_code" :stepinfo="resourceData"></layoutStep>
									<div class="top">
										<div class="left">
											<img class="avatar" :src="resourceData.resource_info.avatar_url"
												v-if="resourceData.resource_info.avatar_url">
											<img class="avatar" src="../../assets/images/admin.png" v-else>
											<div class="base">
												<p>
													<img class="icon" :src="resourceData.resource_info.platform_logo" alt="">
													<span data-v-4d1794f3="" class="name">{{ resourceData.resource_info.platform_name }}</span>
													<!-- <span data-v-4d1794f3="" class="share">共享资源</span> -->
												</p>
												<p class="id">
													<span>账号：</span>{{ resourceData.resource_info.account_code }}
												</p>
											</div>
										</div>
										<div class="right">
											<el-button size="mini"><el-link style="font-size: 12px;" :underline="false"
													:href="resourceData.resource_info.link" target="_blank">进入主页</el-link></el-button>
											<el-button
												v-if="(resourceData.resource_info.status == 4 || resourceData.resource_info.status == 1 || resourceData.resource_info.status == 3) && queryParams.type == 'detail' && $parent.$parent.isAuthAction('admin/resources/resources/editresource')"
												type="primary" size="mini" @click="editResourceFormOpen()">编辑</el-button>
										</div>
									</div>
									<div class="center">
										<div class="row">
											<span class="lable">
												<img src="../../assets/images/icon8.png" alt="">性别
											</span>
											{{ resourceData.resource_info.sex }}
											<span class="lable">
												<img src="../../assets/images/icon9.png" alt="">地区
											</span>
											{{ resourceData.resource_info.area }}
											<span class="lable">
												<img src="../../assets/images/icon10.png" alt="">达人类型
											</span>
											{{ resourceData.resource_info.tags }}
											<span class="lable">
												<img src="../../assets/images/icon11.png" alt="">认证信息
											</span>
											{{ resourceData.resource_info.auth_info }}
											<span class="lable">
												<img src="../../assets/images/icon12.png" alt="">所在行业
											</span>
											{{ resourceData.resource_info.profession }}
										</div>
										<div class="des">
											<span data-v-4d1794f3="">达人简介</span>{{ resourceData.resource_info.rdesc }}
										</div>
									</div>
									<div class="bottom">
										<p><span class="lable">粉丝数</span><template
												v-if="resourceData.resource_info.fans_num > 9999"><span>{{
													formatNumberInThousands(resourceData.resource_info.fans_num) }}<span
														class="w">万</span></span></template><template v-else><span>{{
															resourceData.resource_info.fans_num }}</span></template></p>
										<p><span class="lable">获赞数</span><template
												v-if="resourceData.resource_info.like_num > 9999"><span>{{
													formatNumberInThousands(resourceData.resource_info.like_num) }}<span
														class="w">万</span></span></template><template v-else><span>{{
															resourceData.resource_info.like_num }}</span></template></p>
										<p><span class="lable">关注数</span><template
												v-if="resourceData.resource_info.focus_num > 9999"><span>{{
													formatNumberInThousands(resourceData.resource_info.focus_num) }}<span
														class="w">万</span></span></template><template v-else><span>{{
															resourceData.resource_info.focus_num }}</span></template></p>
										<p><span class="lable">作品数</span><template
												v-if="resourceData.resource_info.works_num > 9999"><span>{{
													formatNumberInThousands(resourceData.resource_info.works_num) }}<span
														class="w">万</span></span></template><template v-else><span>{{
															resourceData.resource_info.works_num }}</span></template></p>
										<p><span class="lable">参考阅读数</span><template
												v-if="resourceData.resource_info.average_read_num > 9999"><span>{{
													formatNumberInThousands(resourceData.resource_info.average_read_num) }}<span
														class="w">万</span></span></template><template v-else><span>{{
															resourceData.resource_info.average_read_num }}</span></template></p>
										<p><span class="lable">参考互动数</span><template
												v-if="resourceData.resource_info.average_interaction_num > 9999"><span>{{
													formatNumberInThousands(resourceData.resource_info.average_interaction_num) }}<span
														class="w">万</span></span></template><template v-else><span>{{
															resourceData.resource_info.average_interaction_num }}</span></template></p>
									</div>
								</div>
								<div class="resourceDetailTable">
									<el-tabs v-model="activeNameB">
										<el-tab-pane label="刊例价" name="first">
											<div class="content" v-if="queryParams.type == 'detail'">
												<div class="top">
													<el-button type="primary" size="mini" @click="rsrelevanceOpen()"
														v-if="resourceData.resource_info.status == 4">关联供应商</el-button>
													<el-button size="mini" @click="updatePriceOpen()"
														v-if="resourceData.resource_info.status == 1 || resourceData.resource_info.status == 4">更新刊例价</el-button>
													<el-button size="mini" @click="delrsrelevance()"
														v-if="resourceData.resource_info.status == 4">取消关联</el-button>
													<el-button size="mini" @click="editrsd()"
														v-if="resourceData.resource_info.status == 4">变更默认供应商</el-button>
												</div>
											</div>
										</el-tab-pane>
										<template>
											<div style="margin-top: 15px;">
												<el-table :data="resourceData.resource_price.data" style="width: 100%" row-key="id" ref="table"
													v-loading="loading" @select-all="onSelectAll" @selection-change="selectItem"
													@row-click="onSelectOp" highlight-current-row>
													<el-table-column type="selection" align="center" width="55"
														v-if="queryParams.type == 'detail' && (resourceData.resource_info.status == 1 || resourceData.resource_info.status == 4)">
													</el-table-column>
													<template v-for="(item, index) in resourceData.resource_price.field">
														<el-table-column v-if="item.children" :min-width="item.width" :label="item.title">
															<template v-for="(itemc, indexc) in item.children">
																<el-table-column :min-width="itemc.width" :prop="itemc.prop" :label="itemc.title">
																	<template slot-scope="scope">
																		<div class="price-info-wrapper">
																			<template v-for="(itema, indexa) in scope.row[itemc.prop]">
																				<div class="price-item" v-if="indexa == 0">
																					<span class="price-value">{{ itema }}</span>
																				</div>
																				<div class="price-item" v-if="indexa == 1 && itema">
																					<span class="discount-value" style="color: #fb5555; font-weight: bold;"><i
																							class="zhe">折</i>{{ itema }}</span>
																				</div>
																				<div class="price-item validity-item" v-if="indexa == 2">
																					<el-popover placement="top" title="起始日期:" width="180" trigger="hover"
																						:content="itema">
																						<span class="validity-link" slot="reference">
																							<i class="el-icon-calendar"></i>
																							<span class="validity-text">价格有效期</span>
																						</span>
																					</el-popover>
																				</div>
																			</template>
																		</div>
																	</template>
																</el-table-column>
															</template>
														</el-table-column>
														<el-table-column v-else :min-width="item.width" :prop="item.prop" :label="item.title">
														</el-table-column>
													</template>
												</el-table>
											</div>
										</template>
									</el-tabs>
								</div>
							</div>
							<actionBar v-if="queryParams.type == 'approve' && resourceData.resource_info.account_code"
								:actioninfo="resourceData" :loading.sync="loading"></actionBar>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--编辑-->
		<el-drawer custom-class="k-drawer" :visible.sync="editResourceFormVisiable" direction="rtl" size="70%">
			<el-form :model="editResourceForm" ref="editResourceForm" :size="size" :rules="rules.editResourceForm"
				label-width="140px" v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>编辑资源信息</span>
						<i class="el-icon-close k-drawer-close" @click="editResourceFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content" v-loading="loading">
					<div v-for="(item, index) in editResourceForm.data" :key="index">
						<template v-if="item.type == 'input' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
								:key="item.fieldName">
								<el-input :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
								</el-input>
							</el-form-item>
						</template>
						<template v-if="item.type == 'textarea' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
								:key="item.fieldName">
								<el-input type="textarea" :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
								</el-input>
							</el-form-item>
						</template>
						<template v-if="item.type == 'link' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
								:key="item.fieldName">
								<div style="display: flex;">
									<div style="flex: 1;padding-right:10px;">
										<el-input :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
										</el-input>
									</div>
									<div><el-button type="primary" plain @click="getPlatformData(item)">获取平台数据</el-button></div>
								</div>
							</el-form-item>
						</template>
						<template v-if="item.type == 'select' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'change' }"
								:key="item.fieldName">
								<el-select v-model="item.value" filterable :placeholder="'请选择' + item.fieldDesc" clearable
									style="width: 100%;">
									<el-option v-for="itemc in item.list" :key="itemc.value" :label="itemc.label" :value="itemc.value">
									</el-option>
								</el-select>
							</el-form-item>
						</template>
						<template v-if="item.type == 'select_area' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'change' }"
								:key="item.fieldName">
								<el-cascader style="width: 100%;" filterable clearable :placeholder="'请选择' + item.fieldDesc"
									v-model="item.value" :options="item.list"></el-cascader>
							</el-form-item>
						</template>
						<template v-if="item.type == 'select_tags' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'change' }"
								:key="item.fieldName">
								<el-select popper-class="tags" v-model="item.value" multiple filterable
									:placeholder="'请选择' + item.fieldDesc" clearable style="width: 100%;">
									<el-option v-for="itemc in item.list" :key="itemc.value" :label="itemc.label" :value="itemc.value">
									</el-option>
								</el-select>
							</el-form-item>
						</template>
					</div>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="editResource()" :size='size'>提交</el-button>
					<el-button :size='size' @click="editResourceFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--关联供应商-->
		<el-drawer custom-class="k-drawer" :visible.sync="rsrelevanceFormVisiable" direction="rtl" size="70%">
			<el-form :model="editResourceForm" ref="editResourceForm" :size="size" :rules="rules.editResourceForm"
				label-width="140px" v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>关联供应商</span>
						<i class="el-icon-close k-drawer-close" @click="rsrelevanceFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content" v-loading="loading">
					<div v-for="(item, index) in editResourceForm.infoNull" :key="index">
						<template v-if="item.type == 'input' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
								:key="item.fieldName">
								<el-input :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
								</el-input>
							</el-form-item>
						</template>
						<template v-if="item.type == 'textarea' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
								:key="item.fieldName">
								<el-input type="textarea" :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
								</el-input>
							</el-form-item>
						</template>
						<template v-if="item.type == 'date_range' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
								:key="item.fieldName">
								<el-date-picker v-model="item.value" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
									range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>
						</template>
						<template v-if="item.type == 'select' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: ['change'] }"
								:key="item.fieldName">
								<el-select v-model="item.value" filterable :placeholder="'请搜索' + item.fieldDesc" clearable
									style="width: 100%;">
									<el-option v-for="itemc in item.list" :key="itemc.value" :label="itemc.label" :value="itemc.value">
									</el-option>
								</el-select>
							</el-form-item>
						</template>
						<template v-if="item.type == 'price' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, validator: validatePrice(item.list), trigger: ['blur', 'change'] }"
								:key="item.fieldName">
								<div class="kPrice">
									<div class="flex" v-for="(itemc, indexc) in item.list" :key="indexc">
										<div v-for="(itema, indexa) in itemc" :key="indexa">
											<template v-if="itema.type == 'text'">
												<span>{{ itema.fieldName }}</span>
											</template>
											<template v-if="itema.type == 'input'">
												<el-input placeholder="设置金额" v-model="itema.value"></el-input>
											</template>
										</div>
									</div>
								</div>
							</el-form-item>
						</template>
					</div>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="rsrelevance()" :size='size'>提交</el-button>
					<el-button :size='size' @click="rsrelevanceFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--更新刊例价-->
		<el-drawer custom-class="k-drawer" :visible.sync="updatePriceFormVisiable" direction="rtl" size="70%">
			<el-form :model="editResourceForm" ref="editResourceForm" :size="size" :rules="rules.editResourceForm"
				label-width="140px" v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>更新刊例价</span>
						<i class="el-icon-close k-drawer-close" @click="updatePriceFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content" v-loading="loading">
					<div v-for="(item, index) in editResourceForm.info" :key="index">
						<template v-if="item.type == 'input' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
								:key="item.fieldName">
								<el-input :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
								</el-input>
							</el-form-item>
						</template>
						<template v-if="item.type == 'textarea' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
								:key="item.fieldName">
								<el-input type="textarea" :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
								</el-input>
							</el-form-item>
						</template>
						<template v-if="item.type == 'date_range' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
								:key="item.fieldName">
								<el-date-picker v-model="item.value" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
									range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>
						</template>
						<template v-if="item.type == 'select' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: ['change'] }"
								:key="item.fieldName">
								<el-select v-model="item.value" :disabled="item.fieldDesc == '供应商'" filterable
									:placeholder="'请搜索' + item.fieldDesc" clearable style="width: 100%;">
									<el-option v-for="itemc in item.list" :key="itemc.value" :label="itemc.label" :value="itemc.value">
									</el-option>
								</el-select>
							</el-form-item>
						</template>
						<template v-if="item.type == 'price' && item.isShow">
							<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
								:rules="{ required: item.isRequired ? true : false, validator: validatePrice(item.list), trigger: ['blur', 'change'] }"
								:key="item.fieldName">
								<div class="kPrice">
									<div class="flex" v-for="(itemc, indexc) in item.list" :key="indexc">
										<div v-for="(itema, indexa) in itemc" :key="indexa">
											<template v-if="itema.type == 'text'">
												<span>{{ itema.fieldName }}</span>
											</template>
											<template v-if="itema.type == 'input'">
												<el-input placeholder="设置金额" v-model="itema.value"></el-input>
											</template>
										</div>
									</div>
								</div>
							</el-form-item>
						</template>
					</div>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="updatePrice()" :size='size'>提交</el-button>
					<el-button :size='size' @click="updatePriceFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
	</div>
</template>
<script>
import layoutStep from '../approve/Step.vue'
import actionBar from '../approve/Actionbar.vue'
export default {
	props: ['info'],
	components: {
		layoutStep,
		actionBar
	},
	data () {
		return {
			activeName: 'first',
			activeNameB: 'first',
			editResourceFormVisiable: false,
			rsrelevanceFormVisiable: false,
			updatePriceFormVisiable: false,
			size: 'mini',
			queryParams: '',//跳转页面携带参数
			resourceData: {
				resource_info: {},
				resource_price: {},
				step_info: {}
			},
			loading: false,
			multipleSelection: [],
			editResourceForm: {
				data: {},
				info: {},//更新刊例价，value需要有值，默认有值
				infoNull: {}//关联供应商时，value需处理为空
			},
			rules: {
				editResourceForm: {}
			}
		}
	},
	computed: {
	},
	mounted: function () {
		this.loading = true
		this.queryParams = this.$route.query;
		this.getFiled('', this.queryParams.id, '')
		this.getDetail()
	},
	methods: {
		//获取所有字段
		getFiled (pid, rsid, sid) {
			let params = {}
			if (pid) {
				params.pid = pid
			}
			if (rsid) {
				params.rsid = rsid
			}
			if (sid) {
				params.sid = sid
			}
			this.$api.get('/admin/resources/resources/getfiled', params).then(res => {
				if (res.code === 0) {
					this.editResourceForm.data = res.data.data
					this.editResourceForm.info = res.data.info
					this.editResourceForm.infoNull = JSON.parse(JSON.stringify(res.data.info))
					//关联供应商value处理为空
					for (let i = 0; i < this.editResourceForm.infoNull.length; i++) {
						this.editResourceForm.infoNull[i].value = '';
						if (this.editResourceForm.infoNull[i].type == 'price') {
							this.editResourceForm.infoNull[i].list.forEach((item, index) => {
								item.forEach((itemc, indexc) => {
									itemc.value = ''
								})
							})
						}
					}
					this.loading = false
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//获取详情
		getDetail () {
			let params = {}
			params.id = this.queryParams.id
			if (this.queryParams.set_id) {
				params.set_id = this.queryParams.set_id
			}
			if (this.queryParams.log_id) {
				params.log_id = this.queryParams.log_id
			}
			this.$api.get('/admin/customers/customer/getexamineinfoview', params).then(res => {
				if (res.code === 0) {
					this.resourceData = res.data
					this.loading = false
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//换算万单位
		formatNumberInThousands (num) {
			return (num / 10000).toFixed(2);
		},
		onSelectAll () {
			this.$refs.table.clearSelection();
		},
		selectItem (rows) {
			if (rows.length > 1) {
				const newRows = rows.filter((it, index) => {
					if (index == rows.length - 1) {
						this.$refs.table.toggleRowSelection(it, true);
						return true;
					} else {
						this.$refs.table.toggleRowSelection(it, false);
						return false;
					}
				});
				this.multipleSelection = newRows;
			} else {
				this.multipleSelection = rows;
			}
			this.userId = this.multipleSelection.length
				? this.multipleSelection[0].guid
				: "";
		},
		onSelectOp (row) {
			this.$refs.table.clearSelection();
			this.$refs.table.toggleRowSelection(row, true);
			this.multipleSelection = [];
			this.multipleSelection.push(row);
		},
		//打开编辑资源弹窗
		editResourceFormOpen () {
			this.editResourceFormVisiable = true
		},
		//编辑资源
		editResource () {
			const params = {
				rsid: '',
				data: {}
			}
			for (const item of this.editResourceForm.data) {
				if (item.fieldName == 'area' && !this.editResourceForm[item.fieldName]) {
					params.data[item.fieldName] = []
				} else {
					params.data[item.fieldName] = item.value;
				}

			}
			params.rsid = this.queryParams.id
			this.$refs['editResourceForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/resources/resources/editresource', params).then(res => {
						if (res.code === 0) {
							//刷新页面
							window.location.reload();
							this.$message({
								showClose: true,
								message: '修改成功！',
								type: 'success'
							});
							this.editResourceFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		//打开关联供应商弹窗
		rsrelevanceOpen () {
			this.rsrelevanceFormVisiable = true
		},
		//验证价格
		validatePrice (list) {
			return (rule, value, callback) => {
				let returnFor = false
				let checkCost = false
				let bb = []
				list.forEach((element) => {
					// 发现错误状态返回
					if (returnFor) return;
					let aa = []
					element.forEach((item) => {
						// 发现错误状态返回
						if (returnFor) return;
						if (item.type == 'input' && item.value != '' && item.value != '0') {
							aa.push(item.value)
						}
					})
					if (aa.length > 0) {
						aa.forEach((cost) => {
							const pattern = /^\d+(\.\d{1,2})?$/; // 示例正则表达式，验证数字最多两位小数的价格格式
							if (!pattern.test(cost)) {
								// 设置金额报错状态
								checkCost = true
								// 发现错误，直接设置错误状态，不需要向下循环了
								returnFor = true
								return;
							}
						})
						bb.push(1)
					}
				});
				if (checkCost) {
					return callback(new Error('请填写有效价格,金额格式有误'));
				}
				// 为空则表示每一条刊例中，没有填写任何数据
				if (bb.length <= 0) {
					return callback(new Error('刊例价至少填写一项！'));
				}
				callback();
			}
		},
		rsrelevance () {
			const params = {
				rsid: '',
				pricelist: {},
				sid: '',
				price_validity: []
			}
			this.editResourceForm.infoNull.forEach((item, index) => {
				if (item.type == "price") {
					item.list.forEach((itemc, indexc) => {
						itemc.forEach((itema, indexa) => {
							if (itema.type == 'input') {
								params.pricelist[itema.fieldName] = itema.value
							}
						})
					})
				} else {
					params[item.fieldName] = item.value
				}
			})
			params.rsid = this.queryParams.id
			this.$refs['editResourceForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/resources/resources/rsrelevance', params).then(res => {
						if (res.code === 0) {
							//刷新页面
							window.location.reload();
							this.$message({
								showClose: true,
								message: '修改成功！',
								type: 'success'
							});
							this.rsrelevanceFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		//取消关联供应商
		delrsrelevance () {
			if (this.multipleSelection.length > 0) {
				this.$confirm('请确认是否取消关联该供应商！', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(function () {
					this.$api.post('/admin/resources/resources/delrsrelevance', { rsid: this.queryParams.id, sid: this.multipleSelection[0].sid }).then(res => {
						if (res.code === 0) {
							window.location.reload();
							this.$message({
								showClose: true,
								message: res.msg,
								type: 'success'
							});
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}.bind(this))
			} else {
				this.$message.error('请选择操作项');
			}
		},
		//变更默认供应商
		editrsd () {
			if (this.multipleSelection.length > 0) {
				if (this.multipleSelection[0].is_default == 1) {
					this.$message.error('该供应商已为默认供应商!');
				} else {
					this.$confirm('确认变更默认供应商吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(function () {
						this.$api.post('/admin/resources/resources/editrsd', { id: this.queryParams.id, sid: this.multipleSelection[0].sid }).then(res => {
							if (res.code === 0) {
								window.location.reload();
								this.$message({
									showClose: true,
									message: res.msg,
									type: 'success'
								});
							} else {
								this.$message.error(res.msg);
							}
							this.loading = false
						})
					}.bind(this))
				}

			} else {
				this.$message.error('请选择操作项');
			}
		},
		//打开更新刊例价窗口
		updatePriceOpen () {
			if (this.multipleSelection.length > 0) {
				this.updatePriceFormVisiable = true
				this.loading = true
				this.getFiled('', this.queryParams.id, this.multipleSelection[0].sid)
			} else {
				this.$message.error('请选择操作项');
			}
		},
		//更新刊例价
		updatePrice () {
			const params = {
				rsid: '',
				pricelist: {},
				sid: '',
				price_validity: []
			}
			this.editResourceForm.info.forEach((item, index) => {
				if (item.type == "price") {
					item.list.forEach((itemc, indexc) => {
						itemc.forEach((itema, indexa) => {
							if (itema.type == 'input') {
								params.pricelist[itema.fieldName] = itema.value
							}
						})
					})
				} else {
					params[item.fieldName] = item.value
				}
			})
			params.rsid = this.queryParams.id
			this.$refs['editResourceForm'].validate(function (valid) {
				if (valid) {
					this.loading = true
					this.$api.post('/admin/resources/resources/updateprice', params).then(res => {
						if (res.code === 0) {
							this.updatePriceFormVisiable = false;
							//刷新页面
							window.location.reload();
							this.$message({
								showClose: true,
								message: '刊例价更新成功！',
								type: 'success'
							});
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		goBack () {
			window.history.back()
		}
	}
}
</script>
<style lang="scss" scoped>
.resourceCon {
	.addBox {
		margin-top: 60px;
	}

	.fyRadio {
		width: 94px;
		height: 40px;
		background: #fbfbfe;
		border: 1px solid #d7dae2;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 20px;
			height: 20px;
			margin-right: 6px;
		}

		.fyRadioTitle {
			font-size: 14px;
			font-weight: 400;
			color: #78859b;
		}
	}

	.el-radio {
		display: inline-flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
	}
}

.resourceDetailTop {
	.title {
		display: flex;
		align-items: center;
		height: 18px;
		font-weight: 700;

		&:before {
			content: "";
			display: inline-block;
			width: 3px;
			border-radius: 15px;
			height: 100%;
			margin-right: 6px;
			background-color: #fe9027;
		}
	}

	.top {
		display: flex;
		justify-content: space-between;

		.left {
			display: flex;

			.avatar {
				width: 50px;
				height: 50px;
				border-radius: 50%;
				margin-right: 16px;
			}

			.base {
				display: flex;
				height: 50px;
				flex-direction: column;
				justify-content: space-between;

				p {
					line-height: 30px;

					&.id {
						color: #a1a1a1;
						font-size: 14px;
					}
				}

				.share {
					color: #409eff;
					font-size: 12px;
					line-height: 1;
					padding: 4px 10px;
					background: #ecf5ff;
					border-radius: 28px;
					margin-left: 8px;
				}

				.name {
					color: #333;
					font-size: 16px;
					font-weight: 700;
				}
			}

			.icon {
				width: 16px;
				height: 16px;
				margin-right: 2px;
				vertical-align: text-bottom;
			}
		}
	}

	.center {
		margin-top: 20px;
		padding: 20px;
		box-sizing: border-box;
		background: #f9fafd;
		border-radius: 4px;
		color: #333;
		font-size: 14px;

		.row {
			display: flex;
			align-items: center;

			.lable {
				color: #a1a1a1;
				margin-right: 10px;
				margin-left: 50px;
				display: inline-flex;
				align-items: center;

				&:first-child {
					margin-left: 0;
				}
			}
		}

		img {
			width: 16px;
			height: 16px;
			margin-right: 4px;
			vertical-align: bottom;
		}

		.des {
			margin-top: 18px;

			span {
				color: #666;
				margin-right: 10px;
				line-height: 32px;
			}
		}
	}

	.bottom {
		margin: 20px 20px 6px;
		display: flex;

		p {
			margin-right: 50px;
			color: #333;

			span {
				font-weight: 500;
				font-size: 18px;

				&.lable {
					margin-right: 10px;
					font-weight: 400;
					font-size: 14px;
					color: #a1a1a1;
				}

				&.w {
					font-size: 12px;
					font-weight: 400;
				}
			}
		}
	}
}

.resourceDetailTable {
	margin-top: 18px;

	.content {
		.top {
			padding: 15px 0 0;
		}
	}
}

.k-page-common .k-common-con .whiteBox .el-table {
	font-size: 12px !important;
}

.price-info-wrapper {
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 6px 0;
}

.price-item {
	display: flex;
	align-items: center;
	gap: 8px;

	.label-text {
		font-size: 12px;
		color: #909399;
		min-width: 40px;
	}

	.price-value {
		font-size: 12px;
		font-weight: bold;
		color: #303133;
	}
}

.validity-item {
	padding-top: 8px;
	border-top: 1px dashed #e8eaec;
	margin-top: 4px;

	.validity-link {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		font-size: 12px;
		color: #409EFF;
		cursor: pointer;
		transition: color 0.2s ease;

		&:hover {
			color: #66b1ff;
		}

		.validity-text {
			font-size: 12px;
		}
	}
}
</style>